var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDialogClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5371 1.46251C13.942 0.867377 12.9772 0.867377 12.3821 1.46251L7.99963 5.84499L3.61698 1.46234C3.02185 0.867208 2.05711 0.867208 1.46197 1.46234C0.866842 2.05747 0.866842 3.02221 1.46197 3.61735L5.84462 7.99999L1.46197 12.3826C0.866842 12.9778 0.866842 13.9425 1.46197 14.5376C1.75946 14.8351 2.14955 14.9839 2.53948 14.9839C2.9294 14.9839 3.31933 14.8351 3.61698 14.5376L7.99963 10.155L12.3823 14.5376C12.6798 14.8351 13.0698 14.9839 13.4598 14.9839C13.8497 14.9839 14.2396 14.8351 14.5373 14.5376C15.1324 13.9425 15.1324 12.9778 14.5373 12.3826L10.1546 7.99999L14.5373 3.61735C15.1322 3.02238 15.1322 2.05747 14.5371 1.46251Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialogClose);
export default __webpack_public_path__ + "static/media/dialog-close.7ba0e34f.svg";
export { ForwardRef as ReactComponent };